import { render, staticRenderFns } from "./TrashedTeams.vue?vue&type=template&id=1fded245"
import script from "./TrashedTeams.vue?vue&type=script&lang=js"
export * from "./TrashedTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports